<template>
  <div class="approval-table">
    <div class="table-responsive table-ecs-container">
      <table class="table table-bordered table-ecs-customize">
        <thead>
          <th>
            <input
              :disabled="idsCanCheck.length === 0"
              type="checkbox"
              @click="selectAll"
              v-model="allSelected"
            />
          </th>
          <th>{{ $t("employee.label_employee_code") }}</th>
          <th>{{ $t("employee.label_employee_name") }}</th>
          <th>{{ $t("employee.label_employee_position") }}</th>
          <th>{{ $t("employee.label_employee_division") }}</th>
          <th>{{ $t("commons.label_created_at") }}</th>
          <th>{{ $t("employee.label_employee_date_start") }}</th>
          <th>{{ $t("employee.label_employee_date_end") }}</th>
          <th>Thời gian nghỉ</th>
          <th>{{ $t("commons.label_status_approval") }}</th>
          <th>
            {{ $t("commons.label_sabbatical_leave_type") }}
          </th>
          <th>{{ $t("commons.label_status") }}</th>
          <th>
            {{ $t("commons.label_employee_action") }}
          </th>
        </thead>
        <tbody>
          <template v-if="hasData">
            <tr v-for="(item, index) in items" :key="index">
              <td>
                <input
                  v-if="idsCanCheck.includes(item.id)"
                  type="checkbox"
                  v-model="sabbaticalRequestsApprovals"
                  @click="select(item.id)"
                  :value="item.id"
                />
              </td>
              <td>{{ item.employee_id }}</td>
              <td>{{ item.employee_name }}</td>
              <td>
                {{ item.employee.position.name }}
              </td>
              <td>
                {{
                  objectNotNull(item.employee.department)
                    ? item.employee.department.name
                    : ""
                }}
              </td>
              <td>
                {{ item.updated_at | formatDate }}
              </td>
              <td>{{ item.start_time }} {{ item.start_date | formatDate }}</td>
              <td>{{ item.end_time }} {{ item.end_date | formatDate }}</td>
              <td v-if = "item.reason_type == 4">{{ Math.round(item.number_days_off*480) }} Phút</td>
              <td v-else>{{ item.number_days_off  }} Ngày</td>

              <td class="min-w-240 text-left px-3">
                <div
                  v-for="(item, index) in item.sabbatical_leave_approves"
                  :key="index"
                >
                  <span v-if="item.status"
                    >{{ item.employees[0].name }}:
                    {{ $t(`overtime.employee_approval_${item.status}`) }}</span
                  >
                </div>
              </td>
              <td>
                {{
                  $t(
                    `commons.label_status_sabbatical_leave_type_${item.reason_type}`
                  )
                }}
              </td>
              <td
                v-bind:class="item.status ? 'color-status-' + item.status : ''"
              >
                <CBadge color="secondary">
                  {{ $t(`commons.label_status_approve_${item.status}`) }}
                </CBadge>
                <div v-if="item.editable === false">
                  <span class="status-submit"> Đã submit công </span>
                </div>
              </td>
              <td class="justify-content-center">
                <!-- <router-link
                  :to="{
                    path: `/sabbatical-leave-request/approval/${item.id}`,
                  }"
                > -->
                  <div
                    color="info"
                    variant="outline"
                    square
                    size="sm"
                    class="action-button"
                    @click="showApprovalModal(item.id)"
                  >
                    <img src="../../../assets/icons/pencil-icon.svg" alt="" />
                  </div>
                <!-- </router-link> -->
              </td>
            </tr>
          </template>
          <tr v-else>
            <td colspan="13">
              <a-empty :image="simpleImage" :description="description" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ApproveSabbaticalRequestModal ref="approveRequest" @fetchData="$emit('change')"/>
  </div>
</template>
<script>
import { Empty } from "ant-design-vue";
import ApproveSabbaticalRequestModal from "../modal/ApproveSabbaticalRequestModal.vue";
// import moment from "moment";
export default {
  name: "ApprovalTable",
  components: {
    ApproveSabbaticalRequestModal,
  },
  props: {
    items: {
      type: Array,
      default(items) {
        if (!items) {
          return [];
        }
        return items;
      },
    },
    idsCanCheck: {
      type: Array,
      default(idsCanCheck) {
        if (!idsCanCheck) {
          return [];
        }
        return idsCanCheck;
      },
    },
    allSelectedProp: {
      type: Boolean,
    },
  },
  data() {
    return {
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      description: this.$t("table.label_data_not_found"),
      approveId: null,
      isShowApproveModal: false,
      idsApprovals: [],
      allSelected: this.allSelectedProp ?? false,
      sabbaticalRequestsApprovals: [],
    };
  },
  computed: {
    hasData() {
      return this.items.length > 0;
    },
  },
  // components: { ApproveTimesheetModal },
  methods: {
    unCheckSelectedAll(data) {
      this.allSelected = data;
      this.sabbaticalRequestsApprovals = [];
    },
    handleApproveOk() {
      this.isShowApproveModal = false;
      this.approveId = null;
      this.$emit("change");
    },
    handleApproveCancel() {
      this.isShowApproveModal = false;
      this.approveId = null;
    },
    showApprovalModal(id) {
      this.$refs.approveRequest.show(id)
      // this.isSubmited = isSubmited;
      // this.isShowApproveModal = true;
      // this.approveId = id;
    },
    handleShowNotiLackOfReview() {
      this.isShowApproveModal = false;
    },
    selectAll() {
      this.sabbaticalRequestsApprovals = [];
      // this.canCheck = [];
      this.allSelected = !this.allSelected;
      if (this.allSelected) {
        this.sabbaticalRequestsApprovals = this.idsCanCheck;
      }
    },
    objectNotNull(obj) {
      if (obj) {
        return Object.keys(obj).length !== 0;
      }
    },
    select(id) {
      this.allSelected = false;
      if (!this.idsApprovals.includes(id)) {
        this.idsApprovals.push(id);
      }
      // const index = this.idsCanCheck.indexOf(id);
      // if (!this.idsCanCheck.includes(id)) {
      //   this.idsCanCheck.push(id);
      // }
    },
  },
  watch: {
    sabbaticalRequestsApprovals() {
      if (
        this.sabbaticalRequestsApprovals.length > 0 &&
        this.sabbaticalRequestsApprovals.length == this.idsCanCheck.length
      ) {
        this.allSelected = true;
      } else {
        this.allSelected = false;
      }
      this.$emit("sabbatical-approved", this.sabbaticalRequestsApprovals);
    },
  },
};
</script>
<style lang="scss" scoped>
.action-button {
  margin: auto;
}
.badge {
  font-weight: 700;
  font-size: 14px;
  background: transparent;
}
.color-status-1 {
  span.badge.badge-secondary {
    background-color: white;
    font-weight: 700;
    color: #f58722;
    font-size: 14px;
  }
}

.color-status-4 {
  span.badge.badge-secondary {
    background-color: white;
    font-weight: 700;
    color: #626262;
    font-size: 14px;
  }
}

.color-status-3 {
  span.badge.badge-secondary {
    background-color: white;
    color: #f03d3e;
    font-weight: 700;
    font-size: 14px;
  }
}

.color-status-2 {
  span.badge.badge-secondary {
    background-color: white;
    color: #17a896;
    font-weight: 700;
    font-size: 14px;
  }
}
.span_time {
  font-weight: bold;
  color: #1190a6;
  margin-left: 5px;
}

.status-submit {
  font-size: 10px;
  font-style: italic;
}
</style>
